import { BaseRouting } from '@aipb/routing';
import { Injectable } from '@angular/core';
import { CustomerConfigEditorEnvService } from '../env';

@Injectable({
  providedIn: 'root'
})
export class CustomerConfigEditorRouting extends BaseRouting {
  static APP_ROUTE = 'customer-config-editor';
  static configPath = ':configId';
  static dashboardProjectListPath = ':applicationId';
  static editorPath = ':applicationId/:projectId/:environmentId';
  private _dashboardProjectList: string[] = [
    BaseRouting.dashboardPath,
    CustomerConfigEditorRouting.dashboardProjectListPath
  ];
  private _editor: string[] = [CustomerConfigEditorRouting.editorPath];

  constructor(customerConfigEditorEnv: CustomerConfigEditorEnvService) {
    super(
      ['/' + CustomerConfigEditorRouting.APP_ROUTE, CustomerConfigEditorRouting.configPath],
      customerConfigEditorEnv
    );
  }

  public editor(
    applicationId: string,
    projectId: string,
    environmentId: string,
    configId: string = this.getConfigId()
  ): void {
    this.nav(this._editor, {
      configId,
      applicationId,
      projectId,
      environmentId
    });
  }

  public editorRouteUrl(
    applicationId: string,
    projectId: string,
    environmentId: string,
    configId: string = this.getConfigId()
  ): string {
    return this.routeUrl(this._editor, {
      configId,
      applicationId,
      projectId,
      environmentId
    });
  }

  public applicationProjectListRouteUrl(applicationId: string, configId: string = this.getConfigId()): string {
    return this.routeUrl(this._dashboardProjectList, {
      configId,
      applicationId
    });
  }
}
